"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getRelevantRevisions = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Revisions = _interopRequireDefault(require("composer-lib/data/model/Revisions"));

var _constants = require("composer-lib/lib/constants");

var getRelevantRevisions = function getRelevantRevisions(state) {
  var initialRevisions = state.revisions;
  var relevantRevisions = initialRevisions.objects.filter(function (_ref) {
    var id = _ref.id,
        object = _ref.object;

    if (id <= 0) {
      return false;
    }

    var parsedBody = JSON.parse(object.body);
    var hasBody = parsedBody && parsedBody.blocks.filter(function (block) {
      return block.text !== '';
    }).length > 0;
    var hasTitle = object.title && object.title !== '';
    return hasBody || hasTitle;
  });
  return initialRevisions.set('objects', relevantRevisions);
};

exports.getRelevantRevisions = getRelevantRevisions;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Revisions.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_REVISIONS_PENDING:
      return state.set('fetchStatus', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_REVISIONS_SUCCEEDED:
      return state.updateOnFetchSuccess(action.data);

    case _ActionTypes.default.FETCH_REVISIONS_FAILED:
      return state.set('fetchStatus', _constants.RequestStatus.FAILED);

    default:
      return state;
  }
};

exports.default = _default;